import { GetListRes } from "./GetListRes";

export enum TableColumnKey {
  Operation = "operation",
  GroupSequence = "groupSequence",
  GroupName = "groupName",
  GroupType = "groupType",
  Status = "status",
  ChainName = "chainName",
  Currency = "currency",
  MaximumAmountLimit = "maximumAmountLimit",
  CreatedBy = "createdBy",
  CreationTime = "creationTime",
  LastModifiedTime = "lastModifiedTime",
  RiskType = "riskType",
  RecipientAddress = "recipientAddress",
  Rating = "rating",
  Probability = "probability",
  RotateAmountLimit = "rotateAmountLimit",
  Active = "active",
  Valid = "valid",
  WalletDisplayName = "walletDisplayName",
  WalletType = "walletType",
}

export type TableRow = { [K in TableColumnKey]?: string } & {
  id: number;
  rawData?: GetListRes;
};
